import React from "react";
import { RatingOverviewContext } from "../context/ratingOverviewContext";
import IRatingList from "../interface/iRatingList";
import SearchResultHeader from "./results/searchResultHeader";
import SearchResultContent from "./results/searchResultContent";
import StyledRatingBox from "../styled/styledRatingBox";
import CustomPagination from "../../../components/pagination/customPagination";

const SearchResults = () => {
  const {
    ratingList,
    setRatingList,
  }: {
    ratingList: IRatingList[];
    setRatingList: React.Dispatch<React.SetStateAction<IRatingList[]>>;
  } = React.useContext(RatingOverviewContext);

  const [paginationSettings, setPaginationSettings] = React.useState({
    page: 1,
    rowsPerPage: 5,
  });

  return (
    <React.Fragment>
      {/* Display the search results*/}
      {ratingList
        .slice(
          (paginationSettings.page - 1) * paginationSettings.rowsPerPage,
          paginationSettings.page * paginationSettings.rowsPerPage
        )
        .map((rating: IRatingList) => (
          <StyledRatingBox key={rating.ratingId}>
            <SearchResultHeader rating={rating} setRatingList={setRatingList} />
            <SearchResultContent rating={rating} />
          </StyledRatingBox>
        ))}

      {/* If no ratings are found, display a message */}
      {ratingList.length === 0 && (
        <StyledRatingBox>
          <p>Keine Bewertungen gefunden.</p>
        </StyledRatingBox>
      )}

      {/* Pagination component to navigate through the results */}
      <CustomPagination
        items={ratingList}
        paginationSettings={paginationSettings}
        setPaginationSettings={setPaginationSettings}
      />
    </React.Fragment>
  );
};

export default SearchResults;
